<div class="container">
  @for (rowIndex of rowsIndices; track rowIndex) {
  <div class="mb-3 w-80">
    <div class="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-6">
      @for (card of cards | slice : rowIndex * itemsPerRow : (rowIndex + 1) * itemsPerRow; track card) {
      <div class="col">
        <div class="card h-100" [attr.data-test]="card.testId + '-card'">
          <app-card [card]="card" [percentageOfDeck]="percentageOfDeck"> </app-card>
        </div>
      </div>
      }
    </div>
    @if (rowIndex < rowsIndices.length - 1) {
    <br />
    }
  </div>
  }
</div>
